import Lookup from 'src/componentes/select2';

const StatusCentroCusto = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/StatusCentroCustoLookup"
      {...props}
    />
  );
};

export default StatusCentroCusto;
